/**
 * Preposição de destino (À / Ao / Às / Aos) + texto sem artigo inicial redundante,
 * para endereçamento em propostas ("À Secretaria…", "Ao Ministério…").
 */

function normalizeComparable(s) {
  return String(s)
    .normalize("NFD")
    .replace(/\p{M}/gu, "")
    .toUpperCase();
}

/** Primeiro token alfabético (permite hífen, ex.: VICE-PRESIDÊNCIA). */
function firstSignificantToken(rest) {
  const t = rest.trim();
  if (!t) return "";
  const m = t.match(/^([A-Za-zÀ-ÿ]+(?:-[A-Za-zÀ-ÿ]+)*)/);
  return m ? normalizeComparable(m[1]) : "";
}

/** Substantivos masculinos comuns em órgãos públicos e empresas. */
const MASCULINE_FIRST = new Set([
  "MINISTERIO",
  "TRIBUNAL",
  "DEPARTAMENTO",
  "GOVERNO",
  "MUNICIPIO",
  "ESTADO",
  "CONSELHO",
  "SERVICO",
  "ORGAO",
  "INSTITUTO",
  "CENTRO",
  "COMITE",
  "NUCLEO",
  "PROGRAMA",
  "PROJETO",
  "FUNDO",
  "BANCO",
  "PARLAMENTO",
  "SENADO",
  "EXERCITO",
  "COMANDO",
  "POLO",
  "SETOR",
  "GABINETE",
  "ESCRITORIO",
  "GRUPO",
  "DISTRITO",
  "TERMINAL",
  "PORTO",
  "AEROPORTO",
  "HOSPITAL",
  "POSTO",
  "NACAO",
]);

/** Substantivos femininos comuns em órgãos públicos e empresas. */
const FEMININE_FIRST = new Set([
  "SECRETARIA",
  "PREFEITURA",
  "UNIVERSIDADE",
  "FUNDACAO",
  "SUPERINTENDENCIA",
  "DIRETORIA",
  "EMPRESA",
  "CAMARA",
  "AGENCIA",
  "COMPANHIA",
  "ESCOLA",
  "FACULDADE",
  "COMISSAO",
  "UNIAO",
  "ADMINISTRACAO",
  "AUTARQUIA",
  "DEFENSORIA",
  "PROCURADORIA",
  "PRESIDENCIA",
  "VICEPRESIDENCIA",
  "COORDENACAO",
  "GERENCIA",
  "SECRETARIAEXECUTIVA",
  "SUBSECRETARIA",
  "REPUBLICA",
  "SOCIEDADE",
  "COOPERATIVA",
  "ASSOCIACAO",
  "FEDERACAO",
  "CONFEDERACAO",
  "ENTIDADE",
  "ORGANIZACAO",
]);

function singularPrepFromRest(rest) {
  const token = firstSignificantToken(rest);
  if (!token) return "Ao";
  const tokenSemHifen = token.replace(/-/g, "");
  if (MASCULINE_FIRST.has(token) || MASCULINE_FIRST.has(tokenSemHifen)) return "Ao";
  if (FEMININE_FIRST.has(token) || FEMININE_FIRST.has(tokenSemHifen)) return "À";
  // Padrão em licitações: destinatário muitas vezes é secretaria/prefeitura.
  return "À";
}

/**
 * @param {string|null|undefined} raw Texto de `ao_instituicao` (pode incluir "A SECRETARIA…", "O MINISTÉRIO…").
 * @returns {{ preposicao: string, nomeExibicao: string }}
 */
export function getPreposicaoInstituicaoDisplay(raw) {
  const texto = String(raw ?? "").trim();
  if (!texto) {
    return { preposicao: "À", nomeExibicao: "" };
  }

  let preposicao;
  let rest = texto;

  if (/^AS\s+/i.test(rest)) {
    preposicao = "Às";
    rest = rest.replace(/^AS\s+/i, "");
  } else if (/^OS\s+/i.test(rest)) {
    preposicao = "Aos";
    rest = rest.replace(/^OS\s+/i, "");
  } else if (/^AO\s+/i.test(rest)) {
    rest = rest.replace(/^AO\s+/i, "");
    preposicao = singularPrepFromRest(rest);
  } else if (/^À\s+/u.test(rest)) {
    rest = rest.replace(/^À\s+/u, "");
    preposicao = singularPrepFromRest(rest);
  } else if (/^A\s+/i.test(rest)) {
    rest = rest.replace(/^A\s+/i, "");
    preposicao = singularPrepFromRest(rest);
  } else if (/^O\s+/i.test(rest)) {
    rest = rest.replace(/^O\s+/i, "");
    preposicao = singularPrepFromRest(rest);
  } else {
    preposicao = singularPrepFromRest(rest);
  }

  const nomeExibicao = rest.trim() || texto;
  return { preposicao, nomeExibicao };
}
